import { render, staticRenderFns } from "./SubmitReview.vue?vue&type=template&id=7497ec80&scoped=true&"
import script from "./SubmitReview.vue?vue&type=script&lang=js&"
export * from "./SubmitReview.vue?vue&type=script&lang=js&"
import style0 from "./SubmitReview.vue?vue&type=style&index=0&id=7497ec80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7497ec80",
  null
  
)

export default component.exports